/**
 * Media Tracker Breakpoint Constants
 * @namespace Constants
 */

/**
 * 0px breakpoint - Base mobile size
 * @type {number}
 * @constant
 */
export const W0: number = 0

/**
 * 240px breakpoint - Very small mobile devices
 * @type {number}
 * @constant
 */
export const W240: number = 240

/**
 * 320px breakpoint - Small mobile devices
 * @type {number}
 * @constant
 */
export const W320: number = 320

/**
 * 480px breakpoint - Mobile devices in landscape
 * @type {number}
 * @constant
 */
export const W480: number = 480

/**
 * 640px breakpoint - Small tablets
 * @type {number}
 * @constant
 */
export const W640: number = 640

/**
 * 768px breakpoint - Tablets
 * @type {number}
 * @constant
 */
export const W768: number = 768

/**
 * 991px breakpoint - Small desktops
 * @type {number}
 * @constant
 */
export const W991: number = 991

/**
 * 1024px breakpoint - Desktop screens
 * @type {number}
 * @constant
 */
export const W1024: number = 1024

/**
 * 1200px breakpoint - Large desktop screens
 * @type {number}
 * @constant
 */
export const W1200: number = 1200

/**
 * 1280px breakpoint - HD desktop screens
 * @type {number}
 * @constant
 */
export const W1280: number = 1280

/**
 * 1728px breakpoint - Large HD screens
 * @type {number}
 * @constant
 */
export const W1728: number = 1728

/**
 * 1920px breakpoint - Full HD screens
 * @type {number}
 * @constant
 */
export const W1920: number = 1920

/**
 * 1980px breakpoint - Large Full HD screens
 * @type {number}
 * @constant
 */
export const W1980: number = 1980

/**
 * 3840px breakpoint - 4K Ultra HD screens
 * @type {number}
 * @constant
 */
export const W3840: number = 3840

/**
 * 4096px breakpoint - Maximum breakpoint
 * @type {number}
 * @constant
 */
export const W4096: number = 4096
